import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

const CHUNK_RECOVERY_FLAG = 'chunk-recovery-reloaded';

function getErrorText(value: unknown): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value instanceof Error) return `${value.name} ${value.message}`.trim();

  const maybeMessage = (value as { message?: unknown }).message;
  if (typeof maybeMessage === 'string') return maybeMessage;

  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

function isChunkLoadFailure(value: unknown): boolean {
  const text = getErrorText(value).toLowerCase();
  return (
    text.includes('failed to fetch dynamically imported module') ||
    text.includes('importing a module script failed') ||
    text.includes('chunkloaderror')
  );
}

function triggerChunkRecoveryReload(reason: unknown): void {
  if (sessionStorage.getItem(CHUNK_RECOVERY_FLAG) === '1') {
    return;
  }

  sessionStorage.setItem(CHUNK_RECOVERY_FLAG, '1');
  console.warn('Detected stale chunk; reloading application once.', reason);
  window.location.reload();
}

function installChunkLoadRecovery(): void {
  window.addEventListener('error', (event) => {
    const err = (event as ErrorEvent).error ?? event.message;
    if (isChunkLoadFailure(err)) {
      triggerChunkRecoveryReload(err);
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadFailure(event.reason)) {
      triggerChunkRecoveryReload(event.reason);
    }
  });
}

function removePrebootLoader() {
  const el = document.getElementById('preboot-loader');
  if (!el) return;

  el.classList.add('fade-out');
  setTimeout(() => el.remove(), 260);
}

installChunkLoadRecovery();

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    removePrebootLoader();
  })
  .catch((err) => {
    console.error('Bootstrap failed', err);
    removePrebootLoader();
  });
